import { mediaQuery } from '@/styles/media';
import styled from 'styled-components';

const Text = styled.h2<{ $footer?: boolean }>`
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => (props.$footer ? '#fff' : 'inherit')};

  ${mediaQuery.sp} {
    font-size: 13px;
  }
`;

type Props = {
  footer?: boolean;
  children: React.ReactNode;
};

const NavLinkHeading: React.FC<Props> = ({ children, footer }) => (
  <Text $footer={footer}>{children}</Text>
);

export default NavLinkHeading;
